module.exports = __webpack_public_path__ + "img/2-3.fe6d66c4.svg";